import React from "react";
import SomeLoader from 'react-loader';

const Loader = ({ loaded, children, loadedClassName }) => {
    return(
        <SomeLoader loaded={loaded} className="loader" loadedClassName={loadedClassName}>
            {children}
        </SomeLoader>
    );
};

export default Loader;